import { Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { InspectorsService } from 'src/app/core/services/inspectors/inspectors.service';
import { InsightsFilters } from '../../models/insights-dashboard.model';
import { CohortsService } from '../../services/cohorts/cohorts.service';
import { SpecialtiesService } from '../../services/specialties/specialties.service';
import { FilterOption, STATUS_OPTIONS, DATE_RANGE_OPTIONS, DEFAULT_FILTERS } from './insights-filters.data';

@Component({
    selector: 'app-ask-ayen-insights-filters',
    templateUrl: './insights-filters.component.html',
    styleUrl: './insights-filters.component.scss',
    standalone: false
})
export class InsightsFiltersComponent implements OnInit {
  @Output() filtersChange = new EventEmitter<InsightsFilters>();

  private cohortsService = inject(CohortsService);
  private specialtiesService = inject(SpecialtiesService);
  private inspectorsService = inject(InspectorsService);

  filters: InsightsFilters = { ...DEFAULT_FILTERS };

  statusOptions = STATUS_OPTIONS;
  dateRangeOptions = DATE_RANGE_OPTIONS;
  cohortOptions: FilterOption[] = [];
  specialtyOptions: FilterOption[] = [];
  expertOptions: FilterOption[] = [];

  ngOnInit(): void {
    this.loadCohorts();
    this.loadSpecialties();
    this.loadExperts();
    // emit the default filters immediately so the parent triggers the initial /dashboard/ load
    this.onChange();
  }

  onChange(): void {
    // custom date_range requires both bounds per the API contract; don't emit a half-set custom range
    if (this.filters.dateRange === 'custom' && (!this.filters.dateFrom || !this.filters.dateTo)) {
      return;
    }
    this.filtersChange.emit({ ...this.filters });
  }

  onDateRangeChange(): void {
    if (this.filters.dateRange !== 'custom') {
      this.filters.dateFrom = null;
      this.filters.dateTo = null;
    }
    this.onChange();
  }

  reset(): void {
    this.filters = { ...DEFAULT_FILTERS };
    this.onChange();
  }

  private loadCohorts(): void {
    this.cohortsService.getCohorts({ page_size: 100 }).subscribe((response: any) => {
      const options = (response?.data || []).map((cohort: { id: number; name: string }) => ({
        value: cohort.id,
        label: cohort.name,
      }));
      this.cohortOptions = options;
    });
  }

  private loadSpecialties(): void {
    this.specialtiesService.getSpecialties({ page_size: 100 }).subscribe((response) => {
      const options = (response?.data || []).map((specialty) => ({
        value: specialty.id,
        label: specialty.name_ar,
      }));
      this.specialtyOptions = options;
    });
  }

  private loadExperts(): void {
    this.inspectorsService.getAvailableInspectors({ page_size: 100 }).subscribe((response: any) => {
      const options = (response?.results || []).map((expert: { id: number; full_name: string }) => ({
        value: expert.id,
        label: expert.full_name,
      }));
      this.expertOptions = options;
    });
  }
}
